import deepFreeze from "./utils/deep-freeze";

import ES_AR from './es-ar';
import ES_BB from './es-bb';
import ES_BO from './es-bo';
import ES_CL from './es-cl';
import ES_CO from './es-co';
import ES_CR from './es-cr';
import ES_CW from './es-cw';
import ES_DO from './es-do';
import ES_EC from './es-ec';
import ES_GT from './es-gt';
import ES_MX from './es-mx';
import ES_NI from './es-ni';
import ES_PA from './es-pa';
import ES_PE from './es-pe';
import ES_PR from './es-pr';
import ES_PY from './es-py';
import ES_SV from './es-sv';
import ES_TT from './es-tt';
import ES_UY from './es-uy';
import ES_VE from './es-ve';
import PR_BR from './pt-br';

export const DEFAULT_LOCALE = 'ar';

export const messages = deepFreeze({
    ar: ES_AR,
    bb: ES_BB,
    bo: ES_BO,
    cl: ES_CL,
    co: ES_CO,
    cr: ES_CR,
    cw: ES_CW,
    do: ES_DO,
    ec: ES_EC,
    gt: ES_GT,
    mx: ES_MX,
    ni: ES_NI,
    pa: ES_PA,
    pe: ES_PE,
    pr: ES_PR,
    py: ES_PY,
    sv: ES_SV,
    tt: ES_TT,
    uy: ES_UY,
    ve: ES_VE,
    br: PR_BR
});
